import AdminLayout from "../../../components/admin/layout/AdminLayout";
import GroupSingleView from "../../../components/admin/group/GroupSingleView";
import { useLocation } from "react-router-dom";

function GroupSingleViewpage() {
  const location = useLocation();
  const id = location.state || {};

  return (
    <AdminLayout>
      <GroupSingleView id={id} />
    </AdminLayout>
  );
}

export default GroupSingleViewpage;
